import clsx from "clsx"
import React, { CSSProperties, PropsWithChildren } from "react"
import { makeStyles, Typography } from "@material-ui/core"
import { StrictOmit } from "shared/Types/helperTypes"

type CardTitleProps = Readonly<
    PropsWithChildren<{
        className?: string
        marginTop?: CSSProperties["marginTop"]
        marginBottom?: CSSProperties["marginBottom"]
    }>
>

type StyleProps = StrictOmit<CardTitleProps, "children" | "className">

const useStyles = makeStyles(() => ({
    cardTitle: (props: StyleProps) => ({
        color: "#334155",
        fontSize: "1.25rem",
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: "0.15px",
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
    }),
}))

export function CardTitle(props: CardTitleProps) {
    const classes = useStyles(props)

    return (
        <Typography variant="h6" className={clsx(props.className, classes.cardTitle)}>
            {props.children}
        </Typography>
    )
}
